import { ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { Observable, startWith, map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PlayerListSecurity } from '../../../shared/models/PlayerListModels';
import { UserModel } from '../../../shared/models/user.model';
import { PlayerListService } from '../../../shared/services/player-list.service';
import { UserService } from '../../../shared/services/user.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-new-list',
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, TranslatePipe],
    templateUrl: './new-list.component.html',
    styleUrl: './new-list.component.css'
})
export class NewListComponent {
  _form: UntypedFormGroup;
  filteredCategories: Observable<string[]>;
  categories: string[] = [];
  users: UserModel[] = [];
  selected: string[] = [];
  loadedCats: boolean = false;
  loadedUsers: boolean = false;
  loadedList: boolean = false;
  isLoading: boolean = false;

  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  constructor( 
    public formBuilder: UntypedFormBuilder,
    private listService: PlayerListService,
    private userService: UserService,
    private router: Router
  ) {}

  getSecurityFromForm(): UntypedFormArray{
    return this._form.controls['PlayerListSecurity'] as UntypedFormArray;
  }

  getUsers(security: PlayerListSecurity[]){
    this.userService.getAllScoutsActive()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data=>{
        this.users = data as UserModel[];
        var accessrights = this._form.get('PlayerListSecurity') as UntypedFormArray;
        accessrights.clear();
        this.users.forEach(function(e) {
          var fb = new FormBuilder();
            var group = fb.group({
              UserId: e.UserId,
              FullName: e.LastName + ', ' + e.FirstName,
              value: security.some(user => user.UserId === e.UserId),
              CanEdit: false
            })
          accessrights.push(group);
        }, this);
        this.loadedUsers = true;
        this.isLoading = false;
        this.cdr.detectChanges();
      });

      //console.log(this._form.value);
  }

  getScout(userid: string): string{
    var user =  this.users.find(user=>user.UserId===userid);
    if(user==null)
      return "";
    else 
      return user.LastName + ", " + user.FirstName;
  }

  submit(){
    //console.log(this._form.value);
    var security: PlayerListSecurity[] = [];
    this._form.controls['PlayerListSecurity'].value.forEach((sec: any)=>{
      //console.log(sec);
      if(sec.value===true){
        var data: PlayerListSecurity = new PlayerListSecurity();
        data.UserId = sec.UserId;
        security.push(data);
      }

      
    });
    
    this.listService.addList(this._form.controls['Description'].value, this._form.controls['Category'].value, security)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result=>{
        this.router.navigateByUrl("lists/details/" + result);
      });
   
  }

  cancel() {
    this.router.navigate(['/lists']);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this._form = this.formBuilder.group({
      Description: ['', [Validators.required]],
      Category: [''],
      PlayerListSecurity: this.formBuilder.array([])
    });
    this.loadedList = true;

    this.filteredCategories = this._form.controls['Category'].valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );

    this.getUsers([]);
    this.listService.getCategories()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data=>{
        this.categories = data as string[];
        this.loadedCats = true;
        this.cdr.detectChanges();
      });
  }


  get PlayerListSecurity(): UntypedFormArray{
    return this._form.get('PlayerListSecurity') as UntypedFormArray;
  }

  private _filter(value: string): string[] {
    if(value=="")
      return this.categories;
    const filterValue = value.toLowerCase();
    
    return this.categories.filter(option => option.toLowerCase().includes(filterValue));
  }

 
}
